<template lang="pug">
v-tooltip(:position="position" dark :color="tooltipColor")
  template(v-slot:activator="{ on }")
    v-btn(
      text
      icon
      color="primary"
      v-bind="$attrs"
      v-on="Object.assign({}, on, $listeners)"
      :aria-label="label"
    )
      v-icon(:large="iconLarge") {{ icon }}
  span {{ label }}
</template>

<script>
export default {
  name: 'TooltipBtn',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    tooltipColor: {
      type: String,
      default: 'primary'
    },
    iconLarge: Boolean
  }
};
</script>
